import React from "react";

const ExploreArrow = ({canRedo, onClick}) => {
  return (
    <svg width="14" height="12" role="img" aria-label="Explore" viewBox="0 0 14 12" fill="#1A73E8" >
        <path d="M7.803.803a.75.75 0 0 1 1.06 0L13.53 5.47a.75.75 0 0 1 0 1.06l-4.666 4.667a.75.75 0 0 1-1.061-1.06l3.386-3.387H1a.75.75 0 0 1 0-1.5h10.19L7.802 1.864a.75.75 0 0 1 0-1.061Z"/>
    </svg>
  );
};

export default ExploreArrow;
